import SectionTitle from "./SectionTitle";
import ScrollReveal from "./ScrollReveal";
import { IconType } from "react-icons";
import {
  FaReact,
  FaServer,
  FaDatabase,
  FaCloud,
  FaLayerGroup,
  FaRobot,
  FaTools,
} from "react-icons/fa";

interface SkillCategory {
  title: string;
  icon: IconType;
  skills: string[];
}

const skillCategories: SkillCategory[] = [
  {
    title: "Frontend Development",
    icon: FaReact,
    skills: [
      "React",
      "Next.js",
      "TypeScript",
      "JavaScript (ES6+)",
      "Angular",
      "Tailwind CSS",
      "HTML5",
      "CSS3",
    ],
  },
  {
    title: "State & Architecture",
    icon: FaLayerGroup,
    skills: [
      "Redux",
      "Redux-Saga",
      "Context API",
      "Component-Driven Development",
      "Reusable Component Libraries",
      "Scalable UI Architecture",
    ],
  },
  {
    title: "Backend Development",
    icon: FaServer,
    skills: [
      "Node.js",
      "Express",
      "REST APIs",
      "WebSockets",
      "Authentication & Authorization",
    ],
  },
  {
    title: "Databases",
    icon: FaDatabase,
    skills: ["MongoDB", "PostgreSQL", "Redis", "IndexedDB"],
  },
  {
    title: "Cloud & DevOps",
    icon: FaCloud,
    skills: [
      "AWS (S3, Amplify)",
      "CI/CD",
      "Git",
      "GitHub",
      "GitLab",
      "Bitbucket",
    ],
  },
  {
    title: "Integrations & AI",
    icon: FaRobot,
    skills: [
      "Claude",
      "Cursor",
      "Agentic Workflows",
      "Prompt Engineering",
      "Postmark",
      "Webhooks",
      "Third-Party APIs",
    ],
  },
  {
    title: "Practices & Tools",
    icon: FaTools,
    skills: [
      "Responsive Design",
      "Code Splitting",
      "Lazy Loading",
      "Performance Optimization",
      "Agile / Scrum",
      "Figma",
      "JIRA",
      "Postman",
    ],
  },
];

const Skills = () => {
  return (
    <section id="skills" className="py-14 scroll-mt-16">
      <ScrollReveal>
        <SectionTitle
          title="Skills"
          subtitle="Technologies and tools I work with to build scalable, end-to-end web applications."
        />
      </ScrollReveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {skillCategories.map((category, index) => {
          const Icon = category.icon;
          return (
            <ScrollReveal key={category.title} delay={index * 100}>
              <div className="p-5 rounded-2xl bg-gray-50 dark:bg-gray-800/50 border border-gray-100 dark:border-gray-800 hover:border-teal-500/30 dark:hover:border-teal-500/30 transition-all card-hover h-full">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2.5">
                  <span className="p-2 rounded-lg bg-teal-500/10 text-teal-500 flex-shrink-0">
                    <Icon className="text-base" />
                  </span>
                  {category.title}
                </h3>
                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill) => (
                    <span
                      key={skill}
                      className="px-3 py-1.5 text-sm rounded-lg bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:border-teal-500 dark:hover:border-teal-500 hover:text-teal-600 dark:hover:text-teal-400 transition-all hover:scale-105 cursor-default"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          );
        })}
      </div>
    </section>
  );
};

export default Skills;
